/**
 * Date-extensions locale Afrikaans [af]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('af', {
    monthNames: ['Januarie','Februarie','Maart','April','Mei','Junie','Julie','Augustus','September','Oktober','November','Desember'],
    monthShortNames: ['Jan','Feb','Mrt','Apr','Mei','Jun','Jul','Aug','Sep','Okt','Nov','Des'],
    dayNames: ['Sondag','Maandag','Dinsdag','Woensdag','Donderdag','Vrydag','Saterdag'],
    dayShortNames: ['Son','Maa','Din','Woe','Don','Vry','Sat']
});
